$(function() {   
	

	$("#newsletter").validate({
	
		 submitHandler: function(form) {
				$(".subscribe_bar .subscribe_nl form button").css('cursor' , 'progress');
				setTimeout(function (){
				$("#email").css ('visibility', 'hidden');
				$(".subscribe_nl h3").html('Thank you!');
				$(".subscribe_nl small").html('Your email has been added to our mailing list.');
				$(".subscribe_bar .subscribe_nl form button").css('cursor' , 'pointer');
				$('#button').attr('disabled','disabled');
				}, 1500); 
			
			return false;
			
			
		 },
		rules: {
			
			email: {
				required: true,
				email: true
			}
		},
		messages: {
			
			email: "Please enter a valid email address"
			
		}
	});

	

	
});
